export default "__VITE_ASSET__D6Og5Dqk__"